export const BUSINESS = {
  name: "Friendly Towing",
  phone: "0416 273 670",
  phoneLink: "tel:+61416273670",
  whatsappNumber: "+61416273670",
  whatsappLink: "https://wa.me/61416273670",
  address: "34 Bliburg St, Jacana VIC 3047",
  rating: "5.0",
  reviewCount: 119,
  hours: "Open 24/7 - Every Day",
  responseTime: "20-30 minutes",
  serviceArea: "Jacana, Broadmeadows, Glenroy, Tullamarine & surrounding suburbs",
  mapEmbedSrc:
    "https://www.google.com/maps?q=34+Bliburg+St,+Jacana+VIC+3047,+Australia&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=34+Bliburg+St,+Jacana+VIC+3047,+Australia",
};

export const SERVICES = [
  {
    slug: "car-towing",
    title: "Car Towing",
    short: "Fast & damage-free vehicle towing across Jacana and Melbourne north.",
    description:
      "Whether you've broken down, been in an accident, or need a transport tow, our flatbed and tilt tray trucks get your vehicle moved safely and quickly — any time of day or night.",
    benefits: [
      "Flatbed & tilt tray trucks",
      "Damage-free loading",
      "All vehicle types",
      "Fast 20-30 min response",
    ],
    icon: "Truck",
  },
  {
    slug: "lockout",
    title: "Car Lockout Assistance",
    short: "Locked out of your car? We'll get you back inside without damage.",
    description:
      "Keys locked inside? Lost them entirely? Our roadside team uses professional non-destructive entry techniques to get you back on the road without scratching paint or breaking trim.",
    benefits: [
      "Non-destructive entry",
      "All makes & models",
      "Day or night service",
      "Affordable flat rates",
    ],
    icon: "KeyRound",
  },
  {
    slug: "local-haulage",
    title: "Local Haulage",
    short: "Reliable local vehicle and equipment transport in and around Jacana.",
    description:
      "Need a vehicle, trailer, or small machinery moved across Melbourne's north? We provide affordable local haulage with on-time pickups and careful handling.",
    benefits: [
      "Same-day bookings",
      "Vehicles & equipment",
      "Transparent pricing",
      "Local Jacana operator",
    ],
    icon: "PackageCheck",
  },
  {
    slug: "special-vehicle",
    title: "Special Vehicle Towing",
    short: "Low-clearance, prestige, 4WD and oversized vehicle specialists.",
    description:
      "Modified, low-clearance, classic, prestige or oversized? We use the right rig — flatbed, dollies, or soft straps — to move your special vehicle without a single scratch.",
    benefits: [
      "Prestige & classic safe",
      "Low-clearance equipped",
      "4WD & oversized",
      "Insured & licensed",
    ],
    icon: "Car",
  },
  {
    slug: "bogged-recovery",
    title: "Bogged Vehicle Recovery",
    short: "Stuck in mud, sand or off-road? We winch you out fast.",
    description:
      "Bogged in mud, sand, soft grass or a ditch? Our recovery team has the winches, snatch straps and experience to get your vehicle out without further damage.",
    benefits: [
      "Heavy-duty winches",
      "Off-road capable",
      "Mud, sand & snow",
      "Careful, no-damage recovery",
    ],
    icon: "LifeBuoy",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    location: "Jacana",
    rating: 5,
    text: "Great service! Affordable pricing and prompt service. Got to me in under 20 minutes when I broke down on the Western Ring Road. Highly recommend Friendly Towing.",
  },
  {
    name: "Daniel P.",
    location: "Broadmeadows",
    rating: 5,
    text: "Quick, professional and took great care of my car. The driver was really friendly and explained everything. Reasonable price too — will use again.",
  },
  {
    name: "Aisha R.",
    location: "Glenroy",
    rating: 5,
    text: "Fast turnaround time and reasonable pricing. Called at 2am after a flat tyre and they were there before I could finish my coffee. Lifesavers.",
  },
  {
    name: "Mark T.",
    location: "Tullamarine",
    rating: 5,
    text: "Locked my keys in the car at the airport. They were out within 25 minutes, no damage, fair price. Couldn't ask for more.",
  },
  {
    name: "Priya K.",
    location: "Coburg",
    rating: 5,
    text: "My 4WD got bogged out near the Merri Creek and these guys winched it out in no time. Polite, careful, and didn't damage a thing.",
  },
  {
    name: "Jason L.",
    location: "Pascoe Vale",
    rating: 5,
    text: "Best towie in the north. Honest pricing, didn't try to upsell, just got the job done. Saved this number in my phone for sure.",
  },
];

export const FAQ = [
  {
    q: "How quickly can you arrive?",
    a: "Most jobs in Jacana and surrounding suburbs we reach within 20-30 minutes. Late nights and emergencies are our specialty.",
  },
  {
    q: "Are you really open 24/7?",
    a: "Yes — every day, every hour. Public holidays included. Just call 0416 273 670.",
  },
  {
    q: "Do you tow all vehicle types?",
    a: "We tow cars, vans, utes, 4WDs, prestige vehicles, classics, motorbikes (with the right setup) and small commercial vehicles.",
  },
  {
    q: "How much does it cost?",
    a: "We're known for our affordable, transparent pricing. Call us with your location and we'll give you a clear quote upfront — no surprises.",
  },
];
